module.exports = __webpack_public_path__ + "static/img/bind_finish.b8e6d4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitation/bind_finish.png
// module id = wDBu
// module chunks = 1